export const siteContent = {
  appName: "Tipbook",
  category: "Track every shift, tip, and payout in one place.",
  headline: "Know what every shift really paid.",
  body:
    "Log tips, tip-out, hourly pay, and shift notes in seconds. Tipbook keeps your service-work income organized so you can spot better nights, compare jobs, and plan the next week with real numbers.",
  appStoreUrl: "https://apps.apple.com/app/tipbook-tip-tracker/id6775181511",
  playStoreUrl:
    "https://play.google.com/store/apps/details?id=app.gntl.tipbook",
  supportEmail: "support@gentle-motion.com",
  proofPoints: ["Shift log", "Tip-out math", "Paycheck checks", "Patterns"],
};
